<template>
  <div>
    <div v-if="loader">
      <div class="spinner"></div>
    </div>

    <!--  Banner Starts Here   -->
    <section class="inner_banner">
      <div class="container_large">
        <div class="inner_banner_content">
          <h1>Dirty Drawz <span>Services</span></h1>
        </div>
      </div>
    </section>
    <!--  Banner Ends Here   -->

    <!--   Main Content Start Here   -->
    <main>
      <section class="default_wraper">
        <div class="container_large">
          <div class="order_form">
            <form method="" action="">
              <div class="order_col">
                <h2 class="text-center">Which service(s) do you need?</h2>
                <div class="small_boxes">
                  <ul>
                    <li>
                      <input
                        type="checkbox"
                        id="washfold"
                        name=""
                        value=""
                        @click="categoryClick('wash')"
                        :checked="show_wash"
                      />
                      <label for="washfold">
                        <img src="/src/assets/images/washer.svg" alt="" />
                        <span>Wash & Fold</span>
                        <span class="sm_text"
                          >${{
                            wash_fold_object && wash_fold_object.value
                              ? wash_fold_object.value
                              : ""
                          }}
                          per lbs (15 Pound min)</span
                        >
                      </label>
                      <div
                        class="unselect_box"
                        @click.prevent="removeAll('wash')"
                        v-if="show_wash"
                      >
                        <i class="fi fi-rr-cross-small"></i>
                      </div>
                    </li>
                    <li>
                      <input
                        type="checkbox"
                        id="dryclean"
                        name=""
                        value=""
                        @click="categoryClick('dry_clean')"
                        :checked="show_dry_clean"
                      />
                      <label for="dryclean">
                        <img src="/src/assets/images/laundry.svg" alt="" />
                        <span>Dry Cleaning</span>
                      </label>
                      <div
                        class="unselect_box"
                        @click.prevent="removeAll('dry_clean')"
                        v-if="show_dry_clean"
                      >
                        <i class="fi fi-rr-cross-small"></i>
                      </div>
                    </li>
                    <li>
                      <input
                        type="checkbox"
                        id="tailoring"
                        name=""
                        value=""
                        @click="categoryClick('tailoring')"
                        :checked="show_tailoring"
                      />
                      <label for="tailoring">
                        <img src="/src/assets/images/sewing.svg" alt="" />
                        <span>Tailoring</span>
                      </label>
                      <div
                        class="unselect_box"
                        @click.prevent="removeAll('tailoring')"
                        v-if="show_tailoring"
                      >
                        <i class="fi fi-rr-cross-small"></i>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="earlist_pickup d-none">
                <i class="fas fa-hand-point-right"></i> Earliest Pickup on
                <span
                  >{{
                    earliest_pickup_date && earliest_pickup_date.month
                      ? earliest_pickup_date.month
                      : ""
                  }}
                  {{
                    earliest_pickup_date && earliest_pickup_date.date
                      ? earliest_pickup_date.date
                      : ""
                  }},
                  {{
                    earliest_pickup_date && earliest_pickup_date.year
                      ? earliest_pickup_date.year
                      : ""
                  }}</span
                >
                |
                <span
                  >{{
                    earliest_pickup_time &&
                    earliest_pickup_time.start_time_split
                      ? earliest_pickup_time.start_time_split
                      : ""
                  }}
                  {{
                    earliest_pickup_time && earliest_pickup_time.start_time_type
                      ? earliest_pickup_time.start_time_type
                      : ""
                  }}</span
                >
              </div>

              <!-- Multiple Cats Selected will show radio of combine & separate delivery -->
              <div
                class="delivery_option"
                v-if="
                  (show_wash && show_dry_clean) ||
                  (show_wash && show_tailoring) ||
                  (show_dry_clean && show_tailoring)
                "
              >
                <ul>
                  <li>
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="radio"
                        name="delivery"
                        id="combined-delivery"
                        :value="false"
                        v-model="is_individual"
                        @click.stop="isChanges(false)"
                      />
                      <label class="form-check-label" for="combined-delivery">
                        <strong>Deliver Together</strong>
                        <p>
                          (I don’t mind waiting for everything to be delivered
                          all together.)
                        </p>
                      </label>
                    </div>
                  </li>

                  <li>
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="radio"
                        name="delivery"
                        id="individual-delivery"
                        :value="true"
                        v-model="is_individual"
                        @click.stop="isChanges(true)"
                      />
                      <label class="form-check-label" for="individual-delivery">
                        <strong>Deliver Separate</strong>
                        <p>
                          (Wash & Fold can be delivered next day, Dry Cleaning
                          and Tailoring may take 4-7 Days.)
                        </p>
                      </label>
                    </div>
                  </li>
                </ul>
              </div>

              <div
                class="customer_note bottom_space"
                v-if="
                  (show_wash && show_dry_clean) ||
                  (show_wash && show_tailoring) ||
                  (show_dry_clean && show_tailoring)
                "
              >
                <img src="/src/assets/images/shopping-bag.svg" alt="" />
                <span
                  >Customers must place Wash and Fold in a Blue Bag, Dry
                  Cleaning and tailoring Must be in a Red Bag. Customer MUST
                  include detailed instructions for tailoring. If this is your
                  first pickup the driver will provide you with both bags during
                  pickup.</span
                >
              </div>
              <!-- if two selected -->

              <!-- <div v-if="(show_wash && show_tailoring) || (show_wash && show_dry_clean) || (show_dry_clean && show_tailoring)"> -->
              <!-- # Combine Calendars  # -->
              <div
                v-if="
                  !is_individual &&
                  (show_wash || show_dry_clean || show_tailoring)
                "
              >
                <div class="order_col top_space">
                  <div class="date_time">
                    <div class="date_slots">
                      <h2>
                        Select Pickup Date
                        <!-- <span v-if="isMultipleCatSelected()">(Together)</span> -->
                      </h2>
                      <div class="date_slots_wraper">
                        <ul>
                          <li
                            :class="{
                              active: data.is_active_pickup_combined[data.date],
                            }"
                            v-for="(data, index) in pickup_dates"
                            :key="index"
                            @click="
                              IsActiveIndex(
                                data,
                                'combined',
                                (combinedPickupIndex = index)
                              )
                            "
                          >
                            <span>{{ data.day ? data.day : "" }} </span>
                            <span>{{ data.month ? data.month : "" }} </span>
                            <span>{{ data.date ? data.date : "" }}</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="time_slots">
                      <h2>Pickup Time</h2>
                      <!-- Same day delivery Divs for Combine -->

                      <div v-if="!isMultipleCatSelected() && show_wash">
                        <div
                          class="same_day_delivery"
                          v-if="!lbl_status_same_day_delivery && wash"
                        >
                          <button
                            type="button"
                            @click.prevent="openSameDayModal('confirm')"
                            :disabled="is_same_day_disabled"
                            :class="{ btn_gray: is_same_day_disabled }"
                          >
                            Same Day Delivery
                          </button>
                        </div>
                        <div
                          class="same_day_delivery pointer"
                          v-if="lbl_status_same_day_delivery"
                        >
                          <button
                            type="button"
                            @click.prevent="openSameDayModal('cancel')"
                          >
                            Remove Same Day Delivery
                          </button>
                        </div>
                      </div>
                      <!-- End - Same day delivery Divs for Combine -->
                      <ul>
                        <li
                          v-for="(data, index) in pickup_time_slots"
                          :class="{
                            disable_timeslot_row: data.time_slot_disabled,
                            active:
                              data.is_active_pickup_timing_combined[data.key],
                          }"
                          :key="index"
                          @click="setTiming('combined', 'pickup', data)"
                        >
                          <span
                            >{{
                              data.start_time_split ? data.start_time_split : ""
                            }}
                            <em>{{
                              data.start_time_type ? data.start_time_type : ""
                            }}</em></span
                          >
                          <span></span>
                          <span
                            >{{
                              data.end_time_split ? data.end_time_split : ""
                            }}
                            <em>{{
                              data.end_time_type ? data.end_time_type : ""
                            }}</em></span
                          >
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div class="order_col">
                  <div class="date_time">
                    <div
                      :class="{ disable_layer: lbl_status_same_day_delivery }"
                    ></div>
                    <div class="date_slots">
                      <h2>
                        Select Delivery Date
                        <!-- <span v-if="isMultipleCatSelected()">(Together) -->
                      </h2>
                      <div class="date_slots_wraper">
                        <ul>
                          <!-- || data.index  <= min_tailoring_delivery_days+combinedPickupIndex || data.index  <= min_dry_clean_delivery_days+combinedPickupIndex -->
                          <li
                            :class="{
                              active:
                                data.is_active_delivery_combined[data.date],
                              is_disabled:
                                data.index <=
                                parseInt(getDefaultHighestDelivery()) +
                                  combinedPickupIndex,
                            }"
                            v-for="(data, index) in delivery_dates"
                            :key="index"
                            @click="
                              IsActiveIndexDelivery(
                                data,
                                'combined',
                                (combinedDeliveryIndexByPickup = index),
                                combinedPickupIndex
                              )
                            "
                          >
                            <span>{{ data.day ? data.day : "" }} </span>
                            <span>{{ data.month ? data.month : "" }} </span>
                            <span>{{ data.date ? data.date : "" }}</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="time_slots">
                      <h2>Drop Off Time</h2>

                      <ul>
                        <li
                          v-for="(data, index) in delivery_time_slots"
                          :class="{
                            active:
                              data.is_active_delivery_timing_combined[data.key],
                          }"
                          :key="index"
                          @click="setTiming('combined', 'delivery', data)"
                        >
                          <span
                            >{{
                              data.start_time_split ? data.start_time_split : ""
                            }}
                            <em>{{
                              data.start_time_type ? data.start_time_type : ""
                            }}</em></span
                          >
                          <span></span>
                          <span
                            >{{
                              data.end_time_split ? data.end_time_split : ""
                            }}
                            <em>{{
                              data.end_time_type ? data.end_time_type : ""
                            }}</em></span
                          >
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <!-- end if two selected -->

              <!-- starting wash calendars-->

              <div
                class="order_col"
                v-if="
                  is_individual &&
                  (show_wash || show_dry_clean || show_tailoring)
                "
              >
                <div class="date_time">
                  <div class="date_slots">
                    <h2>Select Pickup Date</h2>
                    <div class="date_slots_wraper">
                      <ul>
                        <li
                          :class="{
                            active: data.is_active_pickup_wash[data.date],
                          }"
                          v-for="(data, index) in pickup_dates"
                          :key="index"
                          @click="
                            IsActiveIndex(
                              data,
                              'wash',
                              (washPickupIndex = index)
                            )
                          "
                        >
                          <span>{{ data.day ? data.day : "" }} </span>
                          <span>{{ data.month ? data.month : "" }} </span>
                          <span>{{ data.date ? data.date : "" }}</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="time_slots">
                    <h2>Pickup Time</h2>
                    <div
                      v-if="
                        (!isMultipleCatSelected() && show_wash) ||
                        (is_individual && show_wash)
                      "
                    >
                      <div
                        class="same_day_delivery"
                        v-if="!lbl_status_same_day_delivery"
                      >
                        <button
                          type="button"
                          @click.prevent="openSameDayModal('confirm')"
                          :disabled="is_same_day_disabled"
                          :class="{ btn_gray: is_same_day_disabled }"
                        >
                          Same Day Delivery
                        </button>
                      </div>
                      <div
                        class="same_day_delivery pointer"
                        v-if="lbl_status_same_day_delivery"
                      >
                        <button
                          type="button"
                          @click.prevent="openSameDayModal('cancel')"
                        >
                          Remove Same Day Delivery
                        </button>
                        <!-- <div
                      v-if="lbl_status_same_day_delivery"
                      class="text-danger"
                    >
                      Your delivery is same day delivery.
                    </div> -->
                      </div>
                    </div>
                    <ul>
                      <li
                        v-for="(data, index) in pickup_time_slots"
                        :class="{
                          disable_timeslot_row: data.time_slot_disabled,
                          active: data.is_active_pickup_timing_wash[data.key],
                        }"
                        :key="index"
                        @click="setTiming('wash', 'pickup', data)"
                      >
                        <span
                          >{{
                            data.start_time_split ? data.start_time_split : ""
                          }}
                          <em>{{
                            data.start_time_type ? data.start_time_type : ""
                          }}</em></span
                        >
                        <span></span>
                        <span
                          >{{ data.end_time_split ? data.end_time_split : "" }}
                          <em>{{
                            data.end_time_type ? data.end_time_type : ""
                          }}</em></span
                        >
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div class="order_col" v-if="is_individual && show_wash">
                <div class="date_time">
                  <div
                    :class="{ disable_layer: lbl_status_same_day_delivery }"
                  ></div>
                  <div class="date_slots">
                    <h2>Wash & Fold Delivery Date</h2>
                    <div class="date_slots_wraper">
                      <ul>
                        <!-- <li
                        :class="{ active: data.is_active_delivery_wash[data.date], is_disabled: data.index  <= min_wash_delivery_days   }"

                        v-for="(data, index) in delivery_dates"
                        :key="index" @click="IsActiveIndexDelivery(data,'wash', index+1)"

                      > -->
                        <li
                          :class="{
                            active: data.is_active_delivery_wash[data.date],
                            is_disabled:
                              data.index <=
                              min_wash_delivery_days + washPickupIndex,
                          }"
                          v-for="(data, index) in delivery_dates"
                          :key="index"
                          @click="
                            IsActiveIndexDelivery(
                              data,
                              'wash',
                              (washDeliveryIndexByPickup = index),
                              washPickupIndex
                            )
                          "
                        >
                          <span>{{ data.day ? data.day : "" }} </span>
                          <span>{{ data.month ? data.month : "" }} </span>
                          <span>{{ data.date ? data.date : "" }}</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="time_slots">
                    <h2>Drop Off Time</h2>

                    <ul>
                      <li
                        v-for="(data, index) in delivery_time_slots"
                        :class="{
                          active: data.is_active_delivery_timing_wash[data.key],
                        }"
                        :key="index"
                        @click="setTiming('wash', 'delivery', data)"
                      >
                        <span
                          >{{
                            data.start_time_split ? data.start_time_split : ""
                          }}
                          <em>{{
                            data.start_time_type ? data.start_time_type : ""
                          }}</em></span
                        >
                        <span></span>
                        <span
                          >{{ data.end_time_split ? data.end_time_split : "" }}
                          <em>{{
                            data.end_time_type ? data.end_time_type : ""
                          }}</em></span
                        >
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <!-- ending wah -->

              <!-- starting dry_clean -->

              <!-- Dry Clean Calendars -->
              <div
                class="order_col"
                v-if="is_individual && (show_dry_clean || show_tailoring)"
              >
                <div class="date_time">
                  <!-- <div class="disable_layer"></div> -->
                  <div class="date_slots">
                    <h2>
                      Select Dry Cleaning (and/or) Tailoring Delivery Date
                    </h2>
                    <div class="date_slots_wraper">
                      <ul>
                        <li
                          :class="{
                            active:
                              data.is_active_delivery_dry_clean[data.date],
                            is_disabled:
                              data.index <=
                              min_dry_clean_delivery_days + dryPickupIndex,
                          }"
                          v-for="(data, index) in delivery_dates"
                          :key="index"
                          @click="
                            IsActiveIndexDelivery(
                              data,
                              'dry_clean',
                              (dryDeliveryIndexByPickup = index),
                              dryPickupIndex
                            )
                          "
                        >
                          <span>{{ data.day ? data.day : "" }} </span>
                          <span>{{ data.month ? data.month : "" }} </span>
                          <span>{{ data.date ? data.date : "" }}</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="time_slots">
                    <h2>Drop Off Time</h2>
                    <ul>
                      <li
                        v-for="(data, index) in delivery_time_slots"
                        :class="{
                          active:
                            data.is_active_delivery_timing_dry_clean[data.key],
                        }"
                        :key="index"
                        @click="setTiming('dry_clean', 'delivery', data)"
                      >
                        <span
                          >{{
                            data.start_time_split ? data.start_time_split : ""
                          }}
                          <em>{{
                            data.start_time_type ? data.start_time_type : ""
                          }}</em></span
                        >
                        <span></span>
                        <span
                          >{{ data.end_time_split ? data.end_time_split : "" }}
                          <em>{{
                            data.end_time_type ? data.end_time_type : ""
                          }}</em></span
                        >
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div
                class="order_col laundry_bags cleanered"
                v-if="show_dry_clean"
              >
                <h2 class="text-start">Select Dry Cleaning</h2>
                <div class="note_one">
                  <i class="fas fa-star"></i> Prices are only estimates until
                  your items are sorted and weight by the cleaner. Dirty Drawz
                  will update your bill upon delivery.
                </div>
                <!-- <div class="services_notification d-none">
                  You've selected both wash & fold and dry cleaning, please
                  separate the two into different laundry bags.
                </div> -->
                <div class="my-5">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="services_bag"
                      id="cleaner2"
                      :value="false"
                      v-model="is_show_products_dry_clean"
                      @click="IsShowDryCleanProducts(false)"
                    />

                    <label class="form-check-label" for="cleaner2">
                      No, let the cleaner sort for me (and itemize the bill
                      after pickup)
                    </label>
                  </div>
                </div>
                <div class="my-5">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="services_bag"
                      id="myself2"
                      :value="true"
                      v-model="is_show_products_dry_clean"
                      @click="IsShowDryCleanProducts(true)"
                    />
                    <label class="form-check-label" for="myself2">
                      Yes, I'll select my items
                    </label>
                  </div>
                </div>
                <div
                  class="my_items show_cleaned"
                  v-if="is_show_products_dry_clean"
                >
                  <div class="row">
                    <div
                      class="col-6 col-md-4 col-lg-3"
                      v-for="data in dry_clean_products"
                      :key="data"
                    >
                      <div
                        class="item_col"
                        @click.prevent="
                          cartProducts(
                            data,
                            1,
                            'dry_clean',
                            'dry_clean_product'
                          );
                          activate(data.id);
                        "
                        :class="{ active: isActive(data.id) }"
                      >
                        <div class="item_img">
                          <img
                            :src="
                              data.ic
                                ? 'https://s3.us-east-2.amazonaws.com/cleancloudapp/ic/b/' +
                                  data.ic
                                : '/src/assets/images/image-placeholder.png'
                            "
                            class="img-fluid"
                            alt=""
                          />
                        </div>
                        <div class="item_col_content">
                          <span>
                            $
                            {{
                              data.total_price
                                ? parseFloat(data.total_price).toFixed(2)
                                : data.price
                            }}</span
                          >
                          <ul>
                            <li>
                              <button
                                type="button"
                                class="count_btn decrement"
                                @click.stop="
                                  changeQty(data.id, 'descrease', 'dry_clean')
                                "
                              >
                                <i class="fi fi-rr-minus-small"></i>
                              </button>
                            </li>
                            <li>
                              <input
                                type="text"
                                class="item_count"
                                v-model="product[data.id]"
                              />
                              {{ data.name ? data.name : "" }}
                            </li>
                            <li>
                              <button
                                type="button"
                                class="count_btn increment"
                                @click.stop="
                                  changeQty(data.id, 'increase', 'dry_clean')
                                "
                              >
                                <i class="fi fi-rr-plus-small"></i>
                              </button>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- revamp same pickup logic -->
                <!-- <div class="order_col" v-if="is_individual && show_dry_clean">

                  <div class="date_time">
                    <div class="date_slots">
                    <h2>Select Pickup Date and Time (Dry clean)</h2>
                     <div class="date_slots_wraper">
                      <ul>
                        <li
                          :class="{ active: data.is_active_pickup_dry_clean[data.date] }"
                          v-for="(data, index) in pickup_dates"
                          :key="index"
                           @click="IsActiveIndex(data,'dry_clean',  dryPickupIndex=index)"
                        >
                          <span>{{ data.day ? data.day : "" }} </span>
                          <span>{{ data.date ? data.date : "" }}</span>
                        </li>
                      </ul>
                     </div>

                    </div>
                    <div class="time_slots">
                      <ul>
                        <li v-for="(data, index) in pickup_time_slots"
                        :class="{active:data.is_active_pickup_timing_dry_clean[data.key]}"
                          :key="index" @click="setTiming('dry_clean','pickup',data)">
                          <span>{{data.start_time_split ? data.start_time_split :''}} <em>{{data.start_time_type ? data.start_time_type :''}}</em></span> <span></span>
                          <span>{{data.end_time_split ? data.end_time_split :''}}  <em>{{data.end_time_type ? data.end_time_type :''}}</em></span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div> -->

                <!-- <div class="order_btns">
                  <button type="button">Add Another Service</button>
                  <router-link
                    :to="{ name: 'cart' }"
                    class="button primary_button"
                    :disable="!active_el.length && !product.length"
                    >Proceed</router-link
                  >
                </div> -->
              </div>
              <!-- ending dry_clen -->
              <!-- if tailoring section  -->

              <div
                class="order_col laundry_bags tailored"
                v-if="show_tailoring"
              >
                <h2>Select tailoring.</h2>
                <div class="note_one">
                  <i class="fas fa-star"></i> Prices are only estimates until
                  your items are sorted and weight by the cleaner. Dirty Drawz
                  will update your bill upon delivery.
                </div>
                <div class="services_notification d-none">
                  You've selected both wash & fold and dry cleaning, please
                  separate the two into different laundry bags.
                </div>

                <div class="my_items my_tailored">
                  <div class="row">
                    <div
                      class="col-6 col-md-4 col-lg-3"
                      v-for="data in tailoring_products"
                      :key="data"
                    >
                      <div
                        class="item_col"
                        @click.prevent="
                          cartProducts(
                            data,
                            1,
                            'tailoring',
                            'tailoring_product'
                          );
                          activate(data.id);
                        "
                        :class="{ active: isActive(data.id) }"
                      >
                        <div class="item_img">
                          <img
                            :src="
                              data.ic
                                ? 'https://s3.us-east-2.amazonaws.com/cleancloudapp/ic/b/' +
                                  data.ic
                                : '/src/assets/images/image-placeholder.png'
                            "
                            class="img-fluid"
                            alt=""
                          />
                        </div>
                        <div class="item_col_content">
                          <span>
                            $
                            {{
                              data.total_price
                                ? parseFloat(data.total_price).toFixed(2)
                                : data.price
                            }}</span
                          >
                          <ul>
                            <li>
                              <button
                                type="button"
                                class="count_btn decrement"
                                @click.stop="
                                  changeQty(data.id, 'descrease', 'tailoring')
                                "
                              >
                                <i class="fi fi-rr-minus-small"></i>
                              </button>
                            </li>
                            <li>
                              <input
                                type="text"
                                class="item_count"
                                v-model="product[data.id]"
                              />
                              {{ data.name ? data.name : "" }}
                            </li>
                            <li>
                              <button
                                type="button"
                                class="count_btn increment"
                                @click.stop="
                                  changeQty(data.id, 'increase', 'tailoring')
                                "
                              >
                                <i class="fi fi-rr-plus-small"></i>
                              </button>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- end of tailoring -->

              <div class="order_btns">
                <!-- <button type="button">Add Another Service</button> -->
                <router-link
                  :to="{ name: !isDisabled() ? 'cart' : 'order' }"
                  :disabled="isDisabled()"
                  class="button primary_button"
                  >Proceed</router-link
                >
              </div>
            </form>
          </div>
        </div>
      </section>
    </main>
    <!--   Main Content End Here   -->

    <div
      class="modal fade"
      id="deleteModal"
      data-bs-keyboard="false"
      tabindex="-1"
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body">
            <div class="close_modal">
              <button type="button" data-bs-dismiss="modal" aria-label="Close">
                <i class="fi fi-rr-cross-small"></i>
              </button>
            </div>
            <div class="modal_content">
              <h2>Confirmation</h2>
              <p>
                Are you sure to delete this item and all its products from cart
              </p>

              <div class="modal_buttons">
                <button
                  type="button"
                  class="button secondary_button"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  No
                </button>
                <button
                  type="button"
                  class="button primary_button"
                  @click.prevent="deleteItems()"
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- end delete confirmation modal -->

    <!-- <same-day-delivery></same-day-delivery> -->

    <!-- same day delivery start -->

    <!-- Same Day Delivery Modal -->
    <div
      class="modal fade"
      id="sameday_delivery"
      data-bs-keyboard="false"
      tabindex="-1"
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body">
            <div class="close_modal">
              <button type="button" data-bs-dismiss="modal" aria-label="Close">
                <i class="fi fi-rr-cross-small"></i>
              </button>
            </div>
            <div class="modal_content">
              <h2>Same Day Delivery</h2>
              <p v-if="modal_type == 'confirm'">
                <!-- Your order will be delivered tonight between 7pm - 9pm. A $10.00 convenience Fee will be added to your cart. -->
                Express orders only apply to Wash & Fold. Your pickup time will
                be between 10am- 12pm and delivered same days, between 7pm-9pm.
                A $10 convenience free will be added to your cart.
              </p>
              <p v-if="modal_type == 'cancel'">
                Are you sure you wants to cancel same day delivery feature?
              </p>

              <div class="modal_buttons">
                <button
                  type="button"
                  class="button secondary_button"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  No
                </button>
                <button
                  v-if="modal_type == 'confirm'"
                  type="button"
                  class="button primary_button"
                  @click.prevent="confirmSameDayDelivery()"
                >
                  Confirm
                </button>
                <button
                  v-if="modal_type == 'cancel'"
                  type="button"
                  class="button primary_button"
                  @click.prevent="removeSameDayDelivery()"
                >
                  Remove
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- same day delivery end -->
  </div>
</template>
<script>
import productsApis from "../Apis/products";
import webSettings from "../Apis/webSettings";
import sameDayDelivery from "./common/same-day-delivery-modal";
import moment from "moment";

export default {
  components: {
    sameDayDelivery,
  },
  data() {
    return {
      loader: true,
      currentDate: null,

      is_same_day_disabled: true,
      wash_pickup_timing: null,
      lbl_status_same_day_delivery: false,

      is_individual: false,
      is_multiple: false,

      wash_fold_object: null,

      washDeliveryIndexByPickup: null,
      washPickupIndex: 0,

      dryDeliveryIndexByPickup: null,
      dryPickupIndex: 0,

      tailoringDeliveryIndexByPickup: null,
      tailoringPickupIndex: 0,

      combinedDeliveryIndexByPickup: null,
      combinedPickupIndex: 0,

      highest_delivery_days: "",

      active_el: [],
      product: {},
      products: null,
      show_dry_clean: false,
      show_wash: false,
      show_tailoring: false,
      dry_clean_products: [],
      wash_products: [],
      tailoring_products: [],
      cart_products: [],
      default_wash_price: 0,
      default_dry_price: 0,
      default_tailoring_price: 0,
      pickup_dates: null,
      delivery_dates: null,
      pickup_time_slots: [],
      delivery_time_slots: [],
      delete_type: null,
      earliest_pickup_date: null,
      earliest_pickup_time: null,

      min_wash_delivery_days: 3,
      min_dry_clean_delivery_days: 4,
      min_tailoring_delivery_days: 5,

      // for setting default date and time on clicking specific category
      default_wash_pickup: {},
      default_wash_delivery: {},
      default_dry_clean_pickup: {},
      default_dry_clean_delivery: {},
      default_tailoring_pickup: {},
      default_tailoring_delivery: {},
      default_combined_pickup: {},
      default_combined_delivery: {},

      default_wash_product: {
       // id: "10001",
        id: "288",
        name: "Wash and Fold LBS.",
        price: 0,
        type: "wash",
        quantity: 15,
      },

      default_dry_clean_product: {
        id: "20001",
        name: "Dry Clean",
        price: 0,
        type: "dry_clean",
      },
      default_tailoring_product: {
        id: "30001",
        name: "Tailoring",
        price: 0,
        type: "tailoring",
      },

      modal_type: null,

      is_show_products_dry_clean: false,
    };
  },
  methods: {
    IsShowDryCleanProducts(params_type) {
      this.is_show_products_dry_clean = params_type;
    },

    // # Same Day Delivery Functions
    removeSameDayDelivery() {
      this.loader = true;
      localStorage.setItem("wash_same_day_delivery", JSON.stringify(false));
      // if same day is false, making delivery date equal to delivery date (in case it was set to pickup date before becuase of same_day was set true).

      console.log(
        "1444444 this.default_wash_delivery.date",
        this.default_wash_delivery.date
      );
      // localStorage.setItem(
      //   "delivery_date_wash",
      //   JSON.stringify(this.default_wash_delivery.date.formated_date)
      // );

      this.lbl_status_same_day_delivery = false;
      var myModal = new bootstrap.Modal(
        document.getElementById("sameday_delivery")
      );
      this.modal_type = null;
      myModal.hide();

      $("body").removeClass("modal-open");
      $(".fade").removeClass("show");
      $("body").css("padding-right", "0px");

      this.loader = false;
    },
    openSameDayModal(type) {
      this.modal_type = type;
      var myModal = new bootstrap.Modal(
        document.getElementById("sameday_delivery")
      );
      myModal.show();
    },
    // CTA for same day delivery wash
    confirmSameDayDelivery() {
      this.loader = true;
      var myModal = new bootstrap.Modal(
        document.getElementById("sameday_delivery")
      );

      localStorage.setItem("wash_same_day_delivery", JSON.stringify(true));

      // if same day is true, making delivery date equal to pickup date.
      console.log(
        "1444444 this.default_wash_pickup.date",
        this.default_wash_pickup.date
      );

      // localStorage.setItem(
      //   "delivery_date_wash",
      //   JSON.stringify(this.default_wash_pickup.date.formated_date)
      // );

      this.lbl_status_same_day_delivery = true;
      myModal.hide();
      this.modal_type = null;

      $("body").removeClass("modal-open");
      $(".fade").removeClass("show");
      $("body").css("padding-right", "0px");

      this.loader = false;

      // setTimeout(() => {
      //   this.loader = false;
      // }, 1000);
    },
    // -- Same Day Delivery Functions

    // * get is radio buttons change to individual or for combined for deliveries of product forms*/
    isChanges(type) {
      console.log("---------- isChanges CALLED --------------");
      this.loader = true;
      console.log("isChanges() - LOADER SET TRUE");

      this.is_individual = type;

      localStorage.setItem("is_individual", JSON.stringify(this.is_individual));
      // console.log("isChange1-is individual:", this.is_individual);
      if (!this.is_individual) {
        //resetting calender to ist index on change of combine and separate delivery

        this.IsActiveIndex(
          this.default_combined_pickup.date,
          "combined",
          (this.combinedPickupIndex = 0)
        );

        // console.log(
        //   "isChanges-pickups date formated",
        //   this.default_combined_pickup.date
        // );

        localStorage.setItem(
          "pickup_date_combined",
          JSON.stringify(
            !!this.default_combined_pickup.date
              ? this.default_combined_pickup.date.formated_date
              : null
          )
        );

        // this.currentDate = this.default_combined_pickup.date.formated_date;

        // console.log(
        //   "isChange2-> picup time saving localstorage",
        //   this.default_combined_pickup.time
        // );

        localStorage.setItem(
          "pickup_timing_combined",
          JSON.stringify(this.default_combined_pickup.time)
        );

        localStorage.setItem(
          "delivery_date_combined",
          JSON.stringify(
            !!this.default_combined_delivery.date
              ? this.default_combined_delivery.date.formated_date
              : null
          )
        );
        localStorage.setItem(
          "delivery_timing_combined",
          JSON.stringify(this.default_combined_delivery.time)
        );
      } else {
        //resetting the wash pickup calendar (separate delivey case)
        this.IsActiveIndex(
          this.default_wash_pickup.date,
          "wash",
          (this.washPickupIndex = 0)
        );
      }

      this.toggleSameDayDelivery();

      this.loader = false;
      console.log("isChanges() - LOADER SET FALSE");
    },

    /** ##  SELECTING PICKUP DATE AND SETTING DEFAULT DELIVERY DATE OF CALENDARS  ## */
    /**CTA for set pickup active class */
    IsActiveIndex(data, type, index) {
      this.loader = true;
      console.log("IsActiveIndex() - LOADER SET TRUE");

      if (this.is_individual) {
        // Logic Updated - changed: as now we removed multiple pickup calendars so simply making all pickup date equal to Wash n Fold
        this.dryPickupIndex = index;
        this.tailoringPickupIndex = index;

        this.pickup_dates.forEach((element) => {
          if (element.date == data.date) {
            //:: this.currentDate = element.formated_date; // updating current date to selected date (user click on a different date) and also update timeslots again
            var tempDate = moment(this.currentDate).format(
              "YYYY-MM-DD hh:mm:ss"
            );
            console.log("tempDate", tempDate);
            // tempDate.setDate(element.date);
            tempDate = moment(this.currentDate).set("date", element.date);
            console.log("tempDate", tempDate);

            console.log(
              "===== isactiveindex -- current date is ",
              this.currentDate
            );
            console.log("===== isactiveindex --element ", element);

            this.currentDate = tempDate;
            // this.currentDate = moment(this.currentDate._d).format("YYYY-MM-DD hh:mm:ss");

            element.is_active_pickup_wash = { [element.date]: true };

            this.washDeliveryIndexByPickup =
              this.min_wash_delivery_days + index;
            const deliveryObj = this.delivery_dates[
              this.washDeliveryIndexByPickup
            ];
            this.IsActiveIndexDelivery(
              deliveryObj,
              type,
              this.washDeliveryIndexByPickup,
              this.washPickupIndex
            );

            // *setting it in vuex by calling method*/
            this.setOrderDates(type, "pickup", element);
            this.getTimeSlots();
          } else {
            element.is_active_pickup_wash = {};
          }
          return element;
        });

        /** tailoring */

        this.pickup_dates.forEach((element) => {
          if (element.date == data.date) {
            element.is_active_pickup_tailoring = { [element.date]: true };

            this.tailoringDeliveryIndexByPickup =
              this.min_tailoring_delivery_days + index;
            const deliveryObj = this.delivery_dates[
              this.tailoringDeliveryIndexByPickup
            ];
            this.IsActiveIndexDelivery(
              deliveryObj,
              "tailoring",
              this.tailoringDeliveryIndexByPickup,
              this.tailoringPickupIndex
            );

            // *setting it in vuex by calling method*/
            this.setOrderDates("tailoring", "pickup", element);
          } else {
            element.is_active_pickup_tailoring = {};
          }
          return element;
        });

        /** dry cleaning */
        this.pickup_dates.forEach((element) => {
          if (element.date == data.date) {
            element.is_active_pickup_dry_clean = { [element.date]: true };

            this.dryDeliveryIndexByPickup =
              this.min_dry_clean_delivery_days + index;
            const deliveryObj = this.delivery_dates[
              this.dryDeliveryIndexByPickup
            ];
            this.IsActiveIndexDelivery(
              deliveryObj,
              "dry_clean",
              this.dryDeliveryIndexByPickup,
              this.dryPickupIndex
            );

            this.setOrderDates("dry_clean", "pickup", element);
          } else {
            element.is_active_pickup_dry_clean = {};
          }
          return element;
        });
      } else {
        /**combined case */
        this.pickup_dates.forEach((element) => {
          if (element.date == data.date) {
            // :: this is creating problem...  this.currentDate = element.formated_date; // updating current date to selected date (user click on a different date) and also update timeslots again
            var tempDate = moment(this.currentDate).format(
              "YYYY-MM-DD hh:mm:ss"
            );
            console.log("tempDate", tempDate);
            // tempDate.setDate(element.date);
            tempDate = moment(this.currentDate).set("date", element.date);
            console.log("tempDate", tempDate);

            console.log(
              "===== isactiveindex -- current date is ",
              this.currentDate
            );
            console.log("===== isactiveindex --element ", element);

            this.currentDate = tempDate;

            element.is_active_pickup_combined = { [element.date]: true };

            this.combinedDeliveryIndexByPickup =
              this.getDefaultHighestDelivery() + index;
            const deliveryObj = this.delivery_dates[
              this.combinedDeliveryIndexByPickup
            ];
            this.IsActiveIndexDelivery(
              deliveryObj,
              type,
              this.combinedDeliveryIndexByPickup,
              this.combinedPickupIndex
            );

            this.setOrderDates(type, "pickup", element);
            this.getTimeSlots();
          } else {
            element.is_active_pickup_combined = {};
          }
          return element;
        });
      }
      this.loader = false;
      console.log("ISACTIVEINDX() - LOADER SET FALSE");
    },
    IsActiveIndexDelivery(data, type, i, pick_i) {
      // console.log("wash delivery - i ", i, this.min_wash_delivery_days,pick_i)
      if (this.is_individual) {
        if (type == "wash" && i >= this.min_wash_delivery_days + pick_i) {
          this.delivery_dates.forEach((element) => {
            if (element.date == data.date && element.month == data.month) {
              element.is_active_delivery_wash = { [element.date]: true };

              console.log(
                "1444 IsActiveIndexDelivery()=> this.setOrderDates",
                element
              );
              this.setOrderDates(type, "wash", element);
            } else {
              element.is_active_delivery_wash = {};
            }
            return element;
          });
        } else if (
          type == "tailoring" &&
          i >= this.min_tailoring_delivery_days + pick_i
        ) {
          this.delivery_dates.forEach((element) => {
            if (element.date == data.date) {
              element.is_active_delivery_tailoring = { [element.date]: true };
              this.setOrderDates(type, "delivery", element);
            } else {
              element.is_active_delivery_tailoring = {};
            }
            return element;
          });
        } else if (
          type == "dry_clean" &&
          i >= this.min_dry_clean_delivery_days + pick_i
        ) {
          this.delivery_dates.forEach((element) => {
            if (element.date == data.date) {
              element.is_active_delivery_dry_clean = { [element.date]: true };
              this.setOrderDates(type, "delivery", element);
            } else {
              element.is_active_delivery_dry_clean = {};
            }
            return element;
          });
        }
      } else {
        /** for combined */
        if (this.highest_delivery_days == "wash") {
          if (i >= this.min_wash_delivery_days + pick_i) {
            this.delivery_dates.forEach((element) => {
              if (element.date == data.date) {
                element.is_active_delivery_combined = { [element.date]: true };

                console.log(
                  "1444 IsActiveIndexDelivery()=> else (combine) this.setOrderDates",
                  element
                );

                this.setOrderDates(type, "wash", element);
              } else {
                element.is_active_delivery_combined = {};
              }
              return element;
            });
          }
        } else if (this.highest_delivery_days == "dry_clean") {
          if (i >= this.min_dry_clean_delivery_days + pick_i) {
            this.delivery_dates.forEach((element) => {
              if (element.date == data.date) {
                element.is_active_delivery_combined = { [element.date]: true };
                this.setOrderDates(type, "dry_clean", element);
              } else {
                element.is_active_delivery_combined = {};
              }
              return element;
            });
          }
        } else if (this.highest_delivery_days == "tailoring") {
          if (i >= this.min_tailoring_delivery_days + pick_i) {
            this.delivery_dates.forEach((element) => {
              if (element.date == data.date) {
                element.is_active_delivery_combined = { [element.date]: true };
                this.setOrderDates(type, "tailoring", element);
              } else {
                element.is_active_delivery_combined = {};
              }
              return element;
            });
          }
        }

        // this.delivery_dates.forEach((element) => {
        //   if (element.date == data.date) {
        //     element.is_active_pickup_combined = { [element.date]: true };
        //   } else {
        //     element.is_active_pickup_combined = {};
        //   }
        //   return element;
        // });

        // if (
        //   this.min_dry_clean_delivery_days > this.min_tailoring_delivery_days
        // ) {
        //   if (i >= this.min_dry_clean_delivery_days) {
        //     this.delivery_dates.forEach((element) => {
        //       if (element.date == data.date) {
        //         element.is_active_delivery_combined[element.date] = true;
        //         this.setOrderDates(type, "delivery", element);
        //       } else {
        //         element.is_active_delivery_combined = {};
        //       }
        //       return element;
        //     });
        //   }
        // } else if (
        //   this.min_tailoring_delivery_days > this.min_dry_clean_delivery_days
        // ) {
        //   if (i >= this.min_tailoring_delivery_days) {
        //     this.delivery_dates.forEach((element) => {
        //       if (element.date == data.date) {
        //         element.is_active_delivery_combined[element.date] = true;
        //         this.setOrderDates(type, "delivery", element);
        //       } else {
        //         element.is_active_delivery_combined = {};
        //       }
        //       return element;
        //     });
        //   }
        // }
      }
    },
    /** --  SELECTING PICKUP DATE AND SETTING DEFAULT DELIVERY DATE OF CALENDARS  ## */

    getDefaultHighestDelivery() {
      if (this.highest_delivery_days == "wash") {
        return this.min_wash_delivery_days;
      } else if (this.highest_delivery_days == "dry_clean") {
        return this.min_dry_clean_delivery_days;
      } else {
        return this.min_tailoring_delivery_days;
      }
    },

    // * for removing all products from cart for each category*//
    removeAll(type) {
      this.delete_type = type;
      var myModal = new bootstrap.Modal(document.getElementById("deleteModal"));
      myModal.show();
    },
    removeLocalStorageByType(type) {
      if (type == "wash") {
        localStorage.removeItem("pickup_date_wash");
        localStorage.removeItem("pickup_timing_wash");

        // localStorage.removeItem("delivery_date_wash");
        localStorage.removeItem("delivery_timing_wash");
      }
      if (type == "dry_clean") {
        localStorage.removeItem("pickup_date_dry_clean");
        localStorage.removeItem("pickup_timing_dry_clean");

        localStorage.removeItem("delivery_date_dry_clean");
        localStorage.removeItem("delivery_timing_dry_clean");
      }

      if (type == "tailoring") {
        localStorage.removeItem("pickup_date_tailoring");
        localStorage.removeItem("pickup_timing_tailoring");

        localStorage.removeItem("delivery_date_tailoring");
        localStorage.removeItem("delivery_timing_tailoring");
      }
    },
    async deleteItems() {
      this.loader = true;

      if (this.delete_type == "tailoring") {
        const data = JSON.parse(localStorage.getItem("tailoring_products"));
        data.forEach((element) => {
          delete this.product[element.id];
          const index = this.active_el.findIndex((it) => it == element.id);
          // this.active_el.splice(index, 1);
          this.$delete(this.active_el, index);
        });
        // delete default product
        if (this.product && this.product[30001]) {
          const index = this.active_el.findIndex((it) => it == 30001);
          this.active_el.splice(index, 1);
          delete this.product[30001];
        }
        this.$store.dispatch("removeAllTailoring", []);
        this.show_tailoring = false;
      }

      if (this.delete_type == "wash") {
        const data = JSON.parse(localStorage.getItem("wash_products"));
        data.forEach((element) => {
          delete this.product[element.id];
          const index = this.active_el.findIndex((it) => it == element.id);
          this.active_el.splice(index, 1);
        });
        // delete default product quantity
        // if (this.product && this.product[10001]) {
        //   const index = this.active_el.findIndex((it) => it == 10001);
        //   this.active_el.splice(index, 1);
        //   delete this.product[10001];
        // }
         if (this.product && this.product[288]) {
          const index = this.active_el.findIndex((it) => it == 288);
          this.active_el.splice(index, 1);
          delete this.product[288];
        }
        this.$store.dispatch("removeAllWash", []);
        this.show_wash = false;
      }

      if (this.delete_type == "dry_clean") {
        const data = JSON.parse(localStorage.getItem("dry_clean_products"));
        data.forEach((element) => {
          delete this.product[element.id];
          const index = this.active_el.findIndex((it) => it == element.id);
          this.active_el.splice(index, 1);
        });
        // delete default product
        if (this.product && this.product[20001]) {
          const index = this.active_el.findIndex((it) => it == 20001);
          this.active_el.splice(index, 1);
          delete this.product[20001];
        }
        this.$store.dispatch("removeAllDry", []);
        this.show_dry_clean = false;
      }

      this.removeLocalStorageByType(this.delete_type);

      var myModal = new bootstrap.Modal(document.getElementById("deleteModal"));
      myModal.hide();

      $("body").removeClass("modal-open");
      $(".fade").removeClass("show");
      $("body").css("padding-right", "0px");
      this.delete_type = null;

      this.loader = false;
      /** After deleting items of a category, reload the calender to set the correct highest value category (i.e wash vs dry clean vs tailoring) */
      await this.getDates();
    },

    /**CTA for clicking main category */

    async categoryClick(type) {
      if (type == "wash") {
        this.show_wash = !this.show_wash;
        this.addRemoveDefaultWASH();

        if (!this.show_wash) {
            console.log("REMOVING WASH - UNSELECT");

          //if Wash was UN SELECTED, remove all items of it from local storage
          // this.removeAll('wash');
          this.delete_type = type;
          this.deleteItems();
        }
      } else if (type == "dry_clean") {
        this.show_dry_clean = !this.show_dry_clean;
        this.addRemoveDefaultDRY();
        if (!this.show_dry_clean) {
            console.log("REMOVING DRY - UNSELECT");

          //if DryClean was UN SELECTED, remove all items of it from local storage
          // this.removeAll('dry_clean');
           this.delete_type = type;
          this.deleteItems();
        }
      } else if (type == "tailoring") {
        this.show_tailoring = !this.show_tailoring;
        this.addRemoveDefaultTAILOR();

          if (!this.show_tailoring) {
            console.log("REMOVING TAILORING - UNSELECT");
          //if Tailoring was UN SELECTED, remove all items of it from local storage
          // this.removeAll('tailoring');
           this.delete_type = type;
          this.deleteItems();
        }
      }

      if (this.show_wash) {
        // console.log("this.default_wash_pickup", this.default_wash_pickup);
        localStorage.setItem(
          "pickup_date_wash",
          JSON.stringify(
            this.default_wash_pickup.date
              ? this.default_wash_pickup.date.formated_date
              : ""
          )
        );
        localStorage.setItem(
          "pickup_timing_wash",
          JSON.stringify(this.default_wash_pickup.time)
        );

        console.log(
          "1444441 this.default_wash_delivery.date",
          this.default_wash_delivery.date
        );

        // localStorage.setItem(
        //   "delivery_date_wash",
        //   JSON.stringify(
        //     this.default_wash_delivery.date
        //       ? this.default_wash_delivery.date.formated_date
        //       : ""
        //   )
        // );
        localStorage.setItem(
          "delivery_timing_wash",
          JSON.stringify(this.default_wash_delivery.time)
        );

        this.toggleSameDayDelivery();
      }

      if (this.show_dry_clean) {
        localStorage.setItem(
          "pickup_date_dry_clean",
          JSON.stringify(
            this.default_dry_clean_pickup.date
              ? this.default_dry_clean_pickup.date.formated_date
              : ""
          )
        );
        localStorage.setItem(
          "pickup_timing_dry_clean",
          JSON.stringify(this.default_dry_clean_pickup.time)
        );

        localStorage.setItem(
          "delivery_date_dry_clean",
          JSON.stringify(
            this.default_dry_clean_delivery.date
              ? this.default_dry_clean_delivery.date.formated_date
              : ""
          )
        );
        localStorage.setItem(
          "delivery_timing_dry_clean",
          JSON.stringify(this.default_dry_clean_delivery.time)
        );
      }

      if (this.show_tailoring) {
        localStorage.setItem(
          "pickup_date_tailoring",
          JSON.stringify(
            this.default_tailoring_pickup.date
              ? this.default_tailoring_pickup.date.formated_date
              : ""
          )
        );
        localStorage.setItem(
          "pickup_timing_tailoring",
          JSON.stringify(this.default_tailoring_pickup.time)
        );

        localStorage.setItem(
          "delivery_date_tailoring",
          JSON.stringify(
            this.default_tailoring_delivery.date
              ? this.default_tailoring_delivery.date.formated_date
              : ""
          )
        );
        localStorage.setItem(
          "delivery_timing_tailoring",
          JSON.stringify(this.default_tailoring_delivery.time)
        );
      }

      if (this.show_wash && this.show_dry_clean) {
        this.is_multiple = true;

        this.is_individual = false;
        localStorage.setItem("is_individual", "false");
      } else if (this.show_wash && this.show_tailoring) {
        this.is_multiple = true;

        this.is_individual = false;
        localStorage.setItem("is_individual", "false");
      } else if (this.show_dry_clean && this.show_tailoring) {
        this.is_multiple = true;

        this.is_individual = false;
        localStorage.setItem("is_individual", "false");
      } else {
        this.is_multiple = false;
        this.is_individual = true;
        localStorage.setItem("is_individual", "true");
      }

      /** Need to display the calendar again based on the category select/remove */
      await this.getDates();
      await this.getTimeSlots();
    },

    /** adding default product in cart because if he willn't select item then he can order from his default main product */
    addRemoveDefaultWASH() {
      /**addint removing it into vuex */
      if (this.show_wash) {
        this.active_el.push(this.default_wash_product.id);
        this.product[this.default_wash_product.id] = 1;
        this.cartProducts(this.default_wash_product, 1, "wash", "default");
      } else {
        delete this.product[this.default_wash_product.id];
        this.$store.dispatch("removeItem", this.default_wash_product);
        const index = this.active_el.findIndex(
          (it) => it === this.default_wash_product.id
        );
        this.active_el.splice(index, 1);
      }
    },

    /** function handle the remove when click on cross/delete on main category */
    addRemoveDefaultDRY() {
      if (this.show_dry_clean) {
        this.active_el.push(this.default_dry_clean_product.id);
        this.product[this.default_dry_clean_product.id] = 1;
        this.cartProducts(
          this.default_dry_clean_product,
          1,
          "dry_clean",
          "default"
        );
      } else {
        delete this.product[this.default_dry_clean_product.id];
        this.$store.dispatch("removeItem", this.default_dry_clean_product);
        const index = this.active_el.findIndex(
          (it) => it === this.default_dry_clean_product.id
        );
        this.active_el.splice(index, 1);
      }
    },
    addRemoveDefaultTAILOR() {
      if (this.show_tailoring) {
        this.active_el.push(this.default_tailoring_product.id);
        this.product[this.default_tailoring_product.id] = 1;
        this.cartProducts(
          this.default_tailoring_product,
          1,
          "tailoring",
          "default"
        );
      } else {
        delete this.product[this.default_tailoring_product.id];
        this.$store.dispatch("removeItem", this.default_tailoring_product);
        const index = this.active_el.findIndex(
          (it) => it === this.default_tailoring_product.id
        );
        this.active_el.splice(index, 1);
      }
    },

    /*change route for proceed button if there is no product*/
    isDisabled() {
      if (
        this.active_el.length == 0 ||
        !this.active_el.length ||
        !Object.keys(this.product).length
      ) {
        return true;
      }
    },
    // showHideSection() {
    //   $(".cleanered .show_cleaned").toggle($("#myself").prop("checked"));
    // },

    /** adding active class on clicked item */
    isActive(id) {
      const index = this.active_el.findIndex((it) => it == id);
      if (index != -1) {
        return true;
      }
    },

    // push ids to product obj
    activate(id) {
      // setting quantity of product with its id
      if (!this.product[id]) {
        this.product[id] = 1;
      }
      const index = this.active_el.findIndex((it) => it == id);
      if (index === -1) {
        this.active_el.push(id);
        this.active_el = this.active_el.filter(function (el) {
          return el;
        });
      } else {
        // this.active_el.splice(index, 1);
      }
    },

    /** remove ids to product obj */
    deActivate(id) {
      // setting quantity of product with its id
      if (this.product[id]) {
        this.product[id] = 0;
      }
      const index = this.active_el.findIndex((it) => it == id);
      // console.log("before splice - products array:", this.active_el);

      if (index > -1) {
        // if it is already in array
        delete this.product[id];
        this.active_el.splice(index, 1);
        // console.log("after splice - products array:", this.active_el);

        // this.active_el = this.active_el.filter(function (el) {
        //   return el;
        // });
        return true;
      } else {
        // this.active_el.splice(index, 1);
      }
    },

    /**CTA for set pickup/delivert date slots */
    setOrderDates(category, type, data) {
      data.category = category;
      data.type = type;
      this.$store.dispatch("setOrderDate", data);
    },
    /**CTA for set pickup/delivery time slots */
    setTiming(category, type, content) {
      // :: if time slot is disabled, don't set it
      if (content.time_slot_disabled) {
        return;
      }

      this.setActiveTiming(category, type, content);
      /** setting if its for dry clean, tailoring or combined delivery */
      content.category = category;
      content.type = type;
      this.$store.dispatch("setOrderTiming", content);

      /** calling method for disable/enable same day delivery button for wash and fold */
      if (category == "wash" && type == "pickup") {
        this.toggleSameDayDelivery();
      }

      // console.log(type,content);
    },

    // set active class for time slots
    setActiveTiming(category, type, content) {
      if (category == "wash") {
        if (type == "pickup") {
          this.pickup_time_slots.forEach((element) => {
            if (element.id == content.id) {
              element.is_active_pickup_timing_wash[element.key] = true;
            } else {
              element.is_active_pickup_timing_wash = {};
            }
          });
        } else {
          this.delivery_time_slots.forEach((element) => {
            if (element.id == content.id) {
              element.is_active_delivery_timing_wash[element.key] = true;
            } else {
              element.is_active_delivery_timing_wash = {};
            }
          });
        }
      }

      if (category == "dry_clean") {
        if (type == "pickup") {
          this.pickup_time_slots.forEach((element) => {
            if (element.id == content.id) {
              element.is_active_pickup_timing_dry_clean[element.key] = true;
            } else {
              element.is_active_pickup_timing_dry_clean = {};
            }
          });
        } else {
          this.delivery_time_slots.forEach((element) => {
            if (element.id == content.id) {
              element.is_active_delivery_timing_dry_clean[element.key] = true;
            } else {
              element.is_active_delivery_timing_dry_clean = {};
            }
          });
        }
      }

      if (category == "tailoring") {
        if (type == "pickup") {
          this.pickup_time_slots.forEach((element) => {
            if (element.id == content.id) {
              element.is_active_pickup_timing_tailoring[element.key] = true;
            } else {
              element.is_active_pickup_timing_tailoring = {};
            }
          });
        } else {
          this.delivery_time_slots.forEach((element) => {
            if (element.id == content.id) {
              element.is_active_delivery_timing_tailoring[element.key] = true;
            } else {
              element.is_active_delivery_timing_tailoring = {};
            }
          });
        }
      }

      if (category == "combined") {
        if (type == "pickup") {
          this.pickup_time_slots.forEach((element) => {
            if (element.id == content.id) {
              element.is_active_pickup_timing_combined[element.key] = true;
            } else {
              element.is_active_pickup_timing_combined = {};
            }
          });
        } else {
          this.delivery_time_slots.forEach((element) => {
            if (element.id == content.id) {
              element.is_active_delivery_timing_combined[element.key] = true;
            } else {
              element.is_active_delivery_timing_combined = {};
            }
          });
        }
      }
    },

    /** CTA for changing qty of product */
    changeQty(id, type, category) {
      var currentVal = this.product[id];
      if (type == "descrease" && currentVal > 0) {
        currentVal--;
        // console.log("currentVal:", currentVal);
        if (currentVal == 0) {
          // console.log("deactivating this product");
          this.deActivate(id);
        }
        this.product[id] = currentVal;
      } else if (type == "increase") {
        currentVal++;
        this.product[id] = currentVal;
      }

      if (category == "dry_clean") {
        const index = this.dry_clean_products.findIndex((it) => it.id == id);
        if (index != -1) {
          const product = this.dry_clean_products[index];
          // console.log(
          //   "In Change Qt Function - this.dry_clean_products[index]",
          //   this.dry_clean_products[index]
          // );
          this.dry_clean_products[index].total_price =
            product.price * parseInt(currentVal);
          this.dry_clean_products[index].quantity = currentVal;
          product.type = category;

          if (currentVal > 0) {
            this.$store.dispatch("setCart", product);
          } else {
            this.$store.dispatch("removeItem", this.dry_clean_products[index]);
          }
        }
      }
      if (category == "tailoring") {
        const index = this.tailoring_products.findIndex((it) => it.id == id);
        if (index != -1) {
          const product = this.tailoring_products[index];
          this.tailoring_products[index].total_price =
            product.price * parseInt(currentVal);
          this.tailoring_products[index].quantity = currentVal;

          if (currentVal > 0) {
            this.$store.dispatch("setCart", product);
          } else {
            this.$store.dispatch("removeItem", this.tailoring_products[index]);
          }
        }
      }
      this.$forceUpdate();
    },

    /** CTA for adding product into cart */
    cartProducts(product, qty, type, call_from) {
      // console.log("---------------------------------");
      // console.log("Cart Products Called");

      product.type = type;
      product.quantity = this.product[product.id]
        ? this.product[product.id]
        : qty;
      product.total_price = product.price * product.quantity;

      if (call_from == "tailoring_product") {
        this.$store.dispatch("removeItem", this.default_tailoring_product);
        const index = this.tailoring_products.findIndex(
          (it) => it.id === product.id
        );
        if (index != -1) {
          this.tailoring_products[index] = product;
        }
      }
      if (call_from == "dry_clean_product") {
        this.$store.dispatch("removeItem", this.default_dry_clean_product);
        const index = this.dry_clean_products.findIndex(
          (it) => it.id === product.id
        );
        if (index != -1) {
          this.dry_clean_products[index] = product;
        }
      }
      this.$store.dispatch("setCart", product);
    },

    /** CTA for get products from backend*/
    async getProducts() {
      this.products = (await productsApis.getCleanCloudProducts()).data;
      if (this.products && this.products.Products) {
        this.products["Products"].forEach((element) => {
          if (
            element.section &&
            element.section == process.env.WASH_CLEAN_KEY
          ) {
            this.wash_products.push(element);
          }
          if (
            element.section &&
            element.section == process.env.TAILORING_CLEAN_KEY
          ) {
            if (element.id == this.product[element.id]) {
              element.quantity = this.product[element.id];
            }
            this.tailoring_products.push(element);
          }
          if (element.section && element.section == process.env.DRY_CLEAN_KEY) {
            if (element.id == this.product[element.id]) {
              element.quantity = this.product[element.id];
            }
            this.dry_clean_products.push(element);
          }
        });
      }
    },

    async getMinDeliveryDays() {
      try {
        // console.log("getting min delivery days from backend");

        var settings = (await webSettings.requestSettings("get", "")).data;

        // console.log("settings", settings);
        this.min_wash_delivery_days = Number(
          settings.filter(
            (setting_type) => setting_type.key == "min_wash_delivery_days"
          )[0].value
        );
        this.min_dry_clean_delivery_days = Number(
          settings.filter(
            (setting_type) => setting_type.key == "min_dry_clean_delivery_days"
          )[0].value
        );
        this.min_tailoring_delivery_days = Number(
          settings.filter(
            (setting_type) => setting_type.key == "min_tailoring_delivery_days"
          )[0].value
        );

        //---------------

        /** Saving min prices for both tailoring and dry cleaning in localstorage */
        var minDryCleanPrice = Number(
          settings.filter(
            (setting_type) => setting_type.key == "min_dry_clean_price"
          )[0].value
        );

        var minTailoringPrice = Number(
          settings.filter(
            (setting_type) => setting_type.key == "min_tailoring_price"
          )[0].value
        );

        localStorage.setItem(
          "min_tailoring_price",
          JSON.stringify(minTailoringPrice)
        );
        localStorage.setItem(
          "min_dry_clean_price",
          JSON.stringify(minDryCleanPrice)
        );
      } catch (e) {
        // this.error =
        //   "Something went wrong. Please try again or contact support";
      }
    },

    /** CTA for get local storage product to make already added cart products as  active with their qty */
    getLocal() {
      if (localStorage.getItem("wash_products")) {
        const data = JSON.parse(localStorage.getItem("wash_products"));
        if (data && data.length) {
          this.show_wash = true;
          data.forEach((element) => {
            this.product[element.id] = element.quantity;
            this.active_el.push(element.id);
          });
        }
      }
      if (localStorage.getItem("tailoring_products")) {
        const data = JSON.parse(localStorage.getItem("tailoring_products"));
        if (data && data.length) {
          this.show_tailoring = true;
          data.forEach((element) => {
            this.product[element.id] = element.quantity;
            this.active_el.push(element.id);
          });
        }
      }
      if (localStorage.getItem("dry_clean_products")) {
        const data = JSON.parse(localStorage.getItem("dry_clean_products"));
        if (data && data.length) {
          this.show_dry_clean = true;
          data.forEach((element) => {
            this.product[element.id] = element.quantity;
            this.active_el.push(element.id);
          });
        }
      }
      // this.loader = false;
    },

    /**CTA for getting delivery dates for pickup and delivery calendars */
    async getDates() {
      this.loader = true;
      console.log("Get Dates()");

      /** dates */
      const pickUpArr = []; //Array where rest of the dates will be stored

      /** Checking if time is greater than 12PM or not */
      var format = "hh:mm:ss";

      var time = moment(); // gives you current time. no format required.
      // time = moment("21:00:00", format);
      console.log("===== time now, before adding current date", time);

      var timeThresh = moment("19:00:00", format);
      console.log("===== time threshold", timeThresh);

      // let currentDate; delcared in data
      if (time.isAfter(timeThresh)) {
        console.log("Load Next Day as Pickup");
        this.currentDate = moment().add(1, "days"); //0 days back date from today(This is the from date)
      } else {
        // console.log("Load Current Day as Pickup");
        this.currentDate = moment().subtract(0, "days"); //0 days back date from today(This is the from date)
      }

      console.log("===== current date is ", this.currentDate);
      //------------------

      let nextDate = moment().add(30, "days"); //Date after 30 days from today (This is the end date)
      let deliveryNextDate = moment().add(35, "days"); //Date after 35 days from today (This is the end date)

      //extracting date from objects in YYYY-MM-DD format
      // this.currentDate = moment(this.currentDate._d).format(
      //   "YYYY-MM-DD hh:mm:ss"
      // ); // :: This format is not working on IOS - Chrome
      
      this.currentDate = moment(this.currentDate._d).format('l');
      console.log("getDates() => CurrentDate is:", this.currentDate);

      // nextDate = moment(nextDate._d).format("YYYY-MM-DD hh:mm:ss"); // :: This format is not working on IOS - Chrome
      nextDate = moment(nextDate._d).format('l');

      // deliveryNextDate = moment(deliveryNextDate._d).format(
      //   "YYYY-MM-DD hh:mm:ss"
      // ); // :: This format is not working on IOS - Chrome

        deliveryNextDate = moment(deliveryNextDate._d).format(
        'l'
      );

      console.log("deliveryNextDate", deliveryNextDate);

      //creating JS date objects
      console.log("new Date()", new Date());
      var start = new Date(this.currentDate); // :: this is also creating problem. setting current date here instead of next one.
      var end = new Date(nextDate);
      var endDelivery = new Date(deliveryNextDate);

      //Logic for getting rest of the dates between two dates("FromDate" to "EndDate") for pickup
      var counter = 1;

      console.log("Start", start);
      console.log("end", end);

      while (start < end) {
        console.log("Get Dates() - First While");

        var year = moment(start).format("YYYY");
        var month = moment(start).format("MMM");
        var week_day = moment(start).format("ddd");
        var date = moment(start).format("DD");
        var formated_date = moment(start).format("YYYY-MM-DD");
        pickUpArr.push({
          index: counter,
          year: year,
          month: month,
          date: date,
          day: week_day,
          formated_date: formated_date,
          is_active_pickup_wash: {},
          is_active_pickup_dry_clean: {},
          is_active_pickup_tailoring: {},
          is_active_pickup_combined: {},
        });
        counter++;
        var newDate = start.setDate(start.getDate() + 1);
        start = new Date(newDate);
      }

      var counter = 1;
      start = new Date(this.currentDate);
      const deliveryArr = [];
      console.log("==== 2nd while -- Start", start);
      console.log("==== 2nd while -- endDelivery", endDelivery);

      while (start < endDelivery) {
        console.log("Get Dates() - 2nd While");

        var year = moment(start).format("YYYY");
        var month = moment(start).format("MMM");
        var week_day = moment(start).format("ddd");
        var date = moment(start).format("DD");
        var formated_date = moment(start).format("YYYY-MM-DD");
        deliveryArr.push({
          index: counter,
          year: year,
          month: month,
          date: date,
          day: week_day,
          formated_date: formated_date,
          is_active_delivery_wash: {},
          is_active_delivery_dry_clean: {},
          is_active_delivery_tailoring: {},
          is_active_delivery_combined: {},
        });
        counter++;
        var newDate = start.setDate(start.getDate() + 1);
        start = new Date(newDate);
      }

      if (pickUpArr && pickUpArr[0]) {
        this.earliest_pickup_date = pickUpArr[0];
      }
      console.log("Get Dates() - 2nd out While -pickUpArr", pickUpArr);

      pickUpArr.map((element, index) => {
        // console.log("inside picupArr.map", element);
        if (index == 0) {
          // console.log("inside picupArr.map => index==0");

          element.is_active_pickup_wash[element.date] = true;
          element.is_active_pickup_dry_clean[element.date] = true;
          element.is_active_pickup_tailoring[element.date] = true;
          element.is_active_pickup_combined[element.date] = true;

          this.default_wash_pickup["date"] = element;

          console.log(
            "1444 - this.default_wash_pickup['date']",
            this.default_wash_pickup["date"]
          );
          this.default_dry_clean_pickup["date"] = element;
          this.default_tailoring_pickup["date"] = element;
          this.default_combined_pickup["date"] = element;
        }
        return element;
      });

      deliveryArr.map((element, index) => {
        /** set default date for delivery */

        // if (index == 0) {
        //   this.default_wash_delivery["date"] = element;
        //   this.default_dry_clean_delivery["date"] = element;
        //   this.default_tailoring_delivery["date"] = element;
        // }

        if (index + 1 == this.min_wash_delivery_days + 1) {
          this.washDeliveryIndexByPickup = this.min_wash_delivery_days + 1;
          element.is_active_delivery_wash[element.date] = true;

          console.log(
            "1444 - this.default_wash_delivery['date']",
            this.default_wash_delivery["date"]
          );

          this.default_wash_delivery["date"] = element;
        } else {
          element.is_active_delivery_wash = {};
        }

        if (index + 1 == this.min_dry_clean_delivery_days + 1) {
          this.dryDeliveryIndexByPickup = this.min_wash_delivery_days + 1;
          element.is_active_delivery_dry_clean[element.date] = true;

          this.default_dry_clean_delivery["date"] = element;
        } else {
          element.is_active_delivery_dry_clean = {};
        }

        if (index + 1 == this.min_tailoring_delivery_days + 1) {
          element.is_active_delivery_tailoring[element.date] = true;
          this.default_tailoring_delivery["date"] = element;
        } else {
          element.is_active_delivery_tailoring = {};
        }

        /**for combined pre selected  */

        // if (
        //   this.min_dry_clean_delivery_days > this.min_tailoring_delivery_days &&
        //   index + 1 == this.min_dry_clean_delivery_days
        // ) {
        //   element.is_active_delivery_combined[element.date] = true;
        // } else if (
        //   this.min_tailoring_delivery_days > this.min_dry_clean_delivery_days &&
        //   index + 1 == this.min_tailoring_delivery_days
        // ) {
        //   element.is_active_delivery_combined[element.date] = true;
        // }

        this.setHighestDeliveryDaysType(index, element);
        return element;
      });

      this.pickup_dates = pickUpArr;
      this.delivery_dates = deliveryArr;

      var tempIndorTogether = !!localStorage.getItem("is_individual")
        ? JSON.parse(localStorage.getItem("is_individual"))
        : false;

      this.isChanges(tempIndorTogether); //setting default value to Combine (if already exist, set that.. otherwise set false)
      this.loader = false;
    },

    /** This function calculates which category out of three (wash&fold, dry clean, tailoring) have the highest delivery days time */
    setHighestDeliveryDaysType(index, element) {
      // console.log("show_wash is", this.show_wash);
      // console.log("show_dry_clean is", this.show_dry_clean);
      // console.log("show_tailoring is", this.show_tailoring);

      /** Is Wash n Fold is the highest in terms of delivery days? */
      if (this.show_wash) {
        if (
          (this.show_dry_clean
            ? this.min_wash_delivery_days >= this.min_dry_clean_delivery_days
              ? true
              : false
            : true) &&
          (this.show_tailoring
            ? this.min_wash_delivery_days >= this.min_tailoring_delivery_days
              ? true
              : false
            : true)
        ) {
          this.highest_delivery_days = "wash";
          console.log("highest is wash");
          // but if
          if (index + 1 == this.min_wash_delivery_days + 1) {
            element.is_active_delivery_combined[element.date] = true;
            this.default_combined_delivery["date"] = element;
          } else {
            element.is_active_delivery_combined = {};
          }
        } else if (!this.show_dry_clean && !this.show_tailoring) {
          // ** If only wash is selected then its the highest. This else can also be accomodate in it's If but it will make it longer and difficult to understand
          this.highest_delivery_days = "wash";
          console.log("highest is wash");
          // but if
          if (index + 1 == this.min_wash_delivery_days + 1) {
            element.is_active_delivery_combined[element.date] = true;
            this.default_combined_delivery["date"] = element;
          } else {
            element.is_active_delivery_combined = {};
          }
        }
      }

      /** Is Dry Clean is the highest in terms of delivery days? */
      if (this.show_dry_clean) {
        if (
          (this.show_wash
            ? this.min_dry_clean_delivery_days >= this.min_wash_delivery_days
              ? true
              : false
            : true) &&
          (this.show_tailoring
            ? this.min_dry_clean_delivery_days >=
              this.min_tailoring_delivery_days
              ? true
              : false
            : true)
        ) {
          this.highest_delivery_days = "dry_clean";
          console.log("highest is dry clean");

          if (index + 1 == this.min_dry_clean_delivery_days + 1) {
            element.is_active_delivery_combined[element.date] = true;
            this.default_combined_delivery["date"] = element;
          } else {
            element.is_active_delivery_combined = {};
          }
        }
      }

      /** Is Tailoring is the highest in terms of delivery days? */
      if (this.show_tailoring) {
        if (
          (this.show_wash
            ? this.min_tailoring_delivery_days >= this.min_wash_delivery_days
              ? true
              : false
            : true) &&
          (this.show_dry_clean
            ? this.min_tailoring_delivery_days >=
              this.min_dry_clean_delivery_days
              ? true
              : false
            : true)
        ) {
          this.highest_delivery_days = "tailoring";
          console.log("highest is tailoring");

          if (index + 1 == this.min_tailoring_delivery_days + 1) {
            element.is_active_delivery_combined[element.date] = true;
            this.default_combined_delivery["date"] = element;
          } else {
            element.is_active_delivery_combined = {};
          }
        }
      }

      /**delivery date should be of min wash selected */
      // if (
      //   this.show_wash &&
      //   this.min_wash_delivery_days > this.min_dry_clean_delivery_days &&
      //   this.min_wash_delivery_days > this.min_tailoring_delivery_days
      // ) {
      //   this.highest_delivery_days = "wash";
      //   console.log("highest is wash");
      //   // but if
      //   if (index + 1 == this.min_wash_delivery_days + 1) {
      //     element.is_active_delivery_combined[element.date] = true;
      //     this.default_combined_delivery["date"] = element;
      //   } else {
      //     element.is_active_delivery_combined = {};
      //   }
      // }

      /**delivery date should be of min dry clean selected */
      // if (
      //   this.show_dry_clean &&
      //   this.min_dry_clean_delivery_days > this.min_wash_delivery_days &&
      //   this.min_dry_clean_delivery_days > this.min_tailoring_delivery_days
      // ) {
      //   this.highest_delivery_days = "dry_clean";
      //   console.log("highest is dry clean");

      //   if (index + 1 == this.min_dry_clean_delivery_days + 1) {
      //     element.is_active_delivery_combined[element.date] = true;
      //     this.default_combined_delivery["date"] = element;
      //   } else {
      //     element.is_active_delivery_combined = {};
      //   }
      // }

      /**delivery date should be of min tailoring selected */
      // if (
      //   this.show_tailoring &&
      //   this.min_tailoring_delivery_days > this.min_wash_delivery_days &&
      //   this.min_tailoring_delivery_days > this.min_dry_clean_delivery_days
      // ) {
      //   this.highest_delivery_days = "tailoring";
      //   console.log("highest is dry clean");

      //   if (index + 1 == this.min_tailoring_delivery_days + 1) {
      //     element.is_active_delivery_combined[element.date] = true;
      //     this.default_combined_delivery["date"] = element;
      //   } else {
      //     element.is_active_delivery_combined = {};
      //   }
      // }

      localStorage.setItem(
        "highest_delivery_days",
        JSON.stringify(this.highest_delivery_days)
      );
    },

    async getTimeSlots() {
      this.loader = true;

      const time_slots = (await productsApis.orderTimeSlots("get", "")).data;
      //reinitializing this.pickup_time_slots & this.delivery_time_slots
      this.pickup_time_slots = [];
      this.delivery_time_slots = [];

      console.log("getTimeSlots() -> time_slots", time_slots);

      if (time_slots) {
        let timeSlotAlreadyChosen = false;

        time_slots.forEach((element, index) => {
          // console.log(index);
          /** split to get only hours from time string */
          element.start_time_split = element.start_time.split(":")[0];
          element.end_time_split = element.end_time.split(":")[0];

          element.is_active_pickup_timing_wash = {};
          element.is_active_pickup_timing_dry_clean = {};
          element.is_active_pickup_timing_tailoring = {};
          element.is_active_pickup_timing_combined = {};

          element.is_active_delivery_timing_wash = {};
          element.is_active_delivery_timing_dry_clean = {};
          element.is_active_delivery_timing_tailoring = {};
          element.is_active_delivery_timing_combined = {};

          element.time_slot_disabled = false; //:: To control the selectability of time slot.

          var format = "hh:mm:ss";

          var time = moment(); // gives you current time. no format required.
          // time = moment("20:18:00", format);

          console.log("---- Current Time is:", time);

          var tempSlot1Thresh = moment("10:00:00", format); // it should compare with date time combined
          var tempSlot2Thresh = moment("12:00:00", format);
          var tempSlot3Thresh = moment("19:00:00", format);

          //:: embedding this.currentDate as currentDate can be a next day being set in getDates function

          tempSlot1Thresh = moment(
            moment(this.currentDate).format("YYYY-MM-DD") + " " + "10:00:00"
          );
          tempSlot2Thresh = moment(
            moment(this.currentDate).format("YYYY-MM-DD") + " " + "12:00:00"
          );
          tempSlot3Thresh = moment(
            moment(this.currentDate).format("YYYY-MM-DD") + " " + "19:00:00"
          );

          console.log("---- current threshold1", tempSlot1Thresh);
          console.log("---- current threshold2", tempSlot2Thresh);
          console.log("---- current threshold1", tempSlot3Thresh);

          console.log(
            "element.key, time, tempSlot1Thresh, timeSlotAlreadyChosen",
            element.key +
              ", " +
              time +
              ", " +
              tempSlot1Thresh +
              ", " +
              timeSlotAlreadyChosen
          );
          if (
            element.key == "pickup_slot_1" &&
            time < tempSlot1Thresh &&
            !timeSlotAlreadyChosen
          ) {
            console.log("---- inside thresh 1");
            timeSlotAlreadyChosen = true;
            this.earliest_pickup_time = element;

            element.is_active_pickup_timing_wash[element.key] = true;
            element.is_active_pickup_timing_dry_clean[element.key] = true;
            element.is_active_pickup_timing_tailoring[element.key] = true;
            element.is_active_pickup_timing_combined[element.key] = true;

            this.default_wash_pickup["time"] = element;
            this.default_dry_clean_pickup["time"] = element;
            this.default_tailoring_pickup["time"] = element;
            this.default_combined_pickup["time"] = element;
          } else if (
            element.key == "pickup_slot_2" &&
            time < tempSlot2Thresh &&
            !timeSlotAlreadyChosen
          ) {
            console.log("---- inside thresh 2");
            timeSlotAlreadyChosen = true;

            this.pickup_time_slots.map((slot) => {
              if (slot.key == "pickup_slot_1") {
                slot.time_slot_disabled = true;
              }
            });

            // this.pickup_time_slots.filter((slot) => {
            //   slot.key == "pickup_slot_1";
            // }).time_slot_disabled = true;

            this.earliest_pickup_time = element;

            element.is_active_pickup_timing_wash[element.key] = true;
            element.is_active_pickup_timing_dry_clean[element.key] = true;
            element.is_active_pickup_timing_tailoring[element.key] = true;
            element.is_active_pickup_timing_combined[element.key] = true;

            this.default_wash_pickup["time"] = element;
            this.default_dry_clean_pickup["time"] = element;
            this.default_tailoring_pickup["time"] = element;
            this.default_combined_pickup["time"] = element;
          } else if (
            element.key == "pickup_slot_3" &&
            time < tempSlot3Thresh &&
            !timeSlotAlreadyChosen
          ) {
            console.log("---- inside thresh 3");

            timeSlotAlreadyChosen = true;

            this.pickup_time_slots.map((slot) => {
              if (slot.key == "pickup_slot_1") {
                slot.time_slot_disabled = true;
              }
            });

            this.pickup_time_slots.map((slot) => {
              if (slot.key == "pickup_slot_2") {
                slot.time_slot_disabled = true;
              }
            });

            this.earliest_pickup_time = element;

            element.is_active_pickup_timing_wash[element.key] = true;
            element.is_active_pickup_timing_dry_clean[element.key] = true;
            element.is_active_pickup_timing_tailoring[element.key] = true;
            element.is_active_pickup_timing_combined[element.key] = true;

            this.default_wash_pickup["time"] = element;
            this.default_dry_clean_pickup["time"] = element;
            this.default_tailoring_pickup["time"] = element;
            this.default_combined_pickup["time"] = element;
          } else {
            // handle this
            console.log("---- inside thresh UNDEFINED ELSE");
          }

          if (element.type == "pickup") {
            this.pickup_time_slots.push(element);
          }
          if (element.type == "delivery") {
            this.delivery_time_slots.push(element);
          }
          if (element.key == "delivery_slot_1") {
            element.is_active_delivery_timing_wash[element.key] = true;
            element.is_active_delivery_timing_dry_clean[element.key] = true;
            element.is_active_delivery_timing_tailoring[element.key] = true;
            element.is_active_delivery_timing_combined[element.key] = true;

            this.default_wash_delivery["time"] = element;
            this.default_dry_clean_delivery["time"] = element;
            this.default_tailoring_delivery["time"] = element;
            this.default_combined_delivery["time"] = element;
          }
        });

        console.log(
          "outside loop: - this.default_wash_pickup =>",
          this.default_wash_pickup
        );
        this.default_wash_pickup && this.default_wash_pickup.time
          ? localStorage.setItem(
              "pickup_timing_wash",
              JSON.stringify(this.default_wash_pickup.time)
            )
          : false;

        this.toggleSameDayDelivery();
      }
      this.loader = false;
    },

    async getDefaultPrices() {
      const prices = (await productsApis.getDefaultPrices()).data;
      if (prices) {
        prices.forEach((element) => {
          if (element.key == "min_wash_price") {
            this.default_wash_price = element.value;
          }
          if (element.key == "min_dry_clean_price") {
            this.default_dry_price = element.value;
          }
          if (element.key == "min_tailoring_price") {
            this.default_tailoring_price = element.value;
          }

          if (element.key == "system_service_fee") {
            localStorage.setItem(
              "system_service_fee",
              JSON.stringify(element.value)
            );
          }
          if (element.key == "wash_premium_charge_fee") {
            localStorage.setItem(
              "wash_premium_charge_fee",
              JSON.stringify(element.value)
            );
          }

          if (element.key == "wash_per_lb_price") {
            this.wash_fold_object = element;
          }

          if (element.key == "min_wash_delivery_days") {
            this.min_wash_delivery_days = parseInt(element.value);
          }
          if (element.key == "min_tailoring_delivery_days") {
            this.min_tailoring_delivery_days = parseInt(element.value);
          }
          if (element.key == "min_dry_clean_delivery_days") {
            this.min_dry_clean_delivery_days = parseInt(element.value);
          }
        });
      }
      if (this.default_wash_price) {
        this.default_wash_product.price = parseFloat(
          this.wash_fold_object.value
        ).toFixed(2);
      }
      if (this.default_dry_price) {
        this.default_dry_clean_product.price = parseFloat(
          this.default_dry_price
        ).toFixed(2);
      }
      if (this.default_tailoring_price) {
        this.default_tailoring_product.price = parseFloat(
          this.default_tailoring_price
        ).toFixed(2);
      }

      /** for card price with quantity */
      if (this.dry_clean_products) {
        this.dry_clean_products.forEach((element) => {
          if (this.product[element.id]) {
            element.quantity = this.product[element.id];
            element.total_price = parseInt(element.quantity) * element.price;

            this.cartProducts(
              element,
              element.quantity,
              "dry_clean",
              "dry_clean_product"
            );
          }
        });
      }
      if (this.tailoring_products) {
        this.tailoring_products.forEach((element) => {
          if (this.product[element.id]) {
            element.quantity = this.product[element.id];
            element.total_price = parseInt(element.quantity) * element.price;

            this.cartProducts(
              element,
              element.quantity,
              "tailoring",
              "tailoring_product"
            );
          }
        });
      }
    },

    isMultipleCatSelected() {
      var selectCount = 0;
      if (this.show_wash) {
        selectCount++;
      }
      if (this.show_dry_clean) {
        selectCount++;
      }
      if (this.show_tailoring) {
        selectCount++;
      }
      if (selectCount > 1) {
        return true;
      } else {
        return false;
      }
    },

    /**
     * enable/disable SAME-DAY-DELIVERY params based on localstorage values  */

    toggleSameDayDelivery() {
      // Disabling Same day based on if pickup time is more than 12pm
      if (
        localStorage.getItem("pickup_timing_wash") &&
        localStorage.getItem("pickup_timing_wash") != "undefined"
      ) {
        this.wash_pickup_timing = JSON.parse(
          localStorage.getItem("pickup_timing_wash")
        );

        if (
          this.wash_pickup_timing.end_time_split <= 12 &&
          this.wash_pickup_timing.start_time_type == "am"
        ) {
          this.is_same_day_disabled = false;
          // localStorage.setItem("wash_same_day_delivery", JSON.stringify(true));
          // this.lbl_status_same_day_delivery = false;
        } else {
          this.is_same_day_disabled = true;
          localStorage.setItem("wash_same_day_delivery", JSON.stringify(false));
          this.lbl_status_same_day_delivery = false;
        }
      }

      // Disabling based on if it is a Combine Delivery (default option) && More than one Categories (i.e wash & dry & tailoring) is selected
      if (this.isMultipleCatSelected() && !this.is_individual) {
        this.is_same_day_disabled = true;
        localStorage.setItem("wash_same_day_delivery", JSON.stringify(false));
        this.lbl_status_same_day_delivery = false;
      }
    },
  },

  // # CREATED() #
  async created() {
    await this.getMinDeliveryDays();

    await this.getProducts();

    this.getLocal();

    // get default price of each category
    this.getDefaultPrices();

    // console.log(this.time_slots);

    await this.getDates();

    /* getting pickup and delivery time slots*/
    await this.getTimeSlots();

    // Getting value of is_individual from localstorage if its already set, otherwise setting it to true by default (since initially no cat is selected so it should be true to individual).
    this.is_individual = !!localStorage.getItem("is_individual")
      ? JSON.parse(localStorage.getItem("is_individual"))
      : true;
    localStorage.setItem("is_individual", JSON.stringify(this.is_individual));

    /** disabling same day delivery for times <=12 */

    this.toggleSameDayDelivery();

    //this.isChanges(false); // setting it to Combine Delivery by default

    if (localStorage.getItem("wash_same_day_delivery")) {
      this.lbl_status_same_day_delivery = JSON.parse(
        localStorage.getItem("wash_same_day_delivery")
      );
    }

    this.loader = false;
    console.log("CREATED() - LOADER SET FALSE");
    // setTimeout(() => {
    //   this.loader = false;
    // }, 1000);
  },

  /**
   *
   * TODO --- UPDATE 13 APRIL 2021
   *
   * CLIENT REMOVED THE SEPARATE DELIVERY CALENDER FOR TAILORING AND INSTEAD MAKING IT SAME AS DRY CLEAN. CLEAN THE CODE AND REMOVE ALL REFERENCES OF TAILORING CALENDER LATER ON
   */
};
</script>
<style scoped>
.my_tailored {
  display: block !important;
}
.is_disabled {
  color: #9cabc4;
}
.btn_gray {
  background: gray !important;
  visibility: hidden !important;
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/order.vue